import React,{useState} from 'react';
import Switch from "react-switch";

const SwitchToggle = (props)=>{
    const [switchData,setSwitchData] = useState(true)
    const handleChange = (checked) =>{
        setSwitchData(checked);
        if(!checked){
            props.setColorData('disabledColor',props.id)
        }else{
            props.setColorData('',props.id)
        }
    }
    return (
        <>
            <label>
                <Switch onChange={handleChange} checked={props.activeData} onColor={"#3879AD"} height	={28} width={56} />
            </label>
        </>
    )
}
export default SwitchToggle